import { Eyebrow } from '@/components/ui';

const QUOTES = [
  {
    initials: 'DM',
    name: 'Dan M.',
    context: 'Intermediate · 14-week streak',
    quote:
      'I ran a spreadsheet for three years because every app wanted me to re-enter my programme. Lift2Fit took the CSV, and now I log a set without looking up from the bench.',
    proof: '139 sets logged in four weeks · 97.3% compliance',
  },
  {
    initials: 'AK',
    name: 'Aisha K.',
    context: 'Beginner · first block',
    quote:
      'The AI coach told me my squat had earned an overload and dropped my bench volume because my RPE was creeping. It explained both. My old spreadsheet never said a word.',
    proof: 'Squat e1RM 144 kg · +6.4% in three weeks',
  },
  {
    initials: 'RS',
    name: 'Rob S.',
    context: 'Advanced · two blocks',
    quote:
      'The watch logging is the part I did not expect to care about. One tap, haptic confirms, rest timer runs on my wrist. My phone stays in the bag.',
    proof: 'Single-tap logging · median 3 taps per set',
  },
];

export function Testimonials() {
  return (
    <section className="border-b border-hairline bg-page-subtle py-20">
      <div className="mx-auto max-w-[1200px] 2xl:max-w-[1440px] min-[1920px]:max-w-[1720px] px-4 sm:px-6">
        <div className="mb-10 flex flex-col gap-4">
          <Eyebrow>Beta feedback</Eyebrow>
          <h2 className="font-display text-h2 font-black uppercase leading-tight tracking-[-0.01em] text-ink md:text-display-2">
            Show the work. Every quote has a number.
          </h2>
        </div>

        <ul className="grid gap-6 md:grid-cols-3">
          {QUOTES.map((item) => (
            <li key={item.name} className="flex flex-col justify-between gap-6 rounded-card border border-hairline bg-surface p-6 shadow-card">
              <p className="text-[14px] leading-relaxed text-ink">“{item.quote}”</p>
              <div className="flex items-center gap-3 border-t border-hairline pt-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center bg-brand-charcoal font-display text-[13px] font-black text-brand-white">
                  {item.initials}
                </span>
                <div className="flex flex-col">
                  <span className="text-[13px] font-bold text-ink">{item.name}</span>
                  <span className="text-[11px] uppercase tracking-[0.06em] text-ink-muted">{item.context}</span>
                  <span className="l2f-tabular mt-1 font-mono text-[11px] text-accent">{item.proof}</span>
                </div>
              </div>
            </li>
          ))}
        </ul>

        <p className="mt-6 text-[11px] text-ink-muted">
          Quotes from our private beta, shortened and used with permission. Numbers are read from the lifter’s own log.
        </p>
      </div>
    </section>
  );
}
